<template>
  <div>
    <v-card class="card-custom-shadow">
      <v-card-text class="fs-12">
        <div class="mb-2 d-flex align-center justify-space-between">
          <span class="fs-14px black--text">Khách hàng:</span>
          <span @click="toggleInfo" v-if="isShowAll">
            <v-icon color="primary" v-if="isShowInfo"> mdi-chevron-up </v-icon>
            <v-icon color="primary" v-else> mdi-chevron-down </v-icon>
          </span>
        </div>
        <v-row dense>
          <v-col cols="12">
            <v-file-input
              v-model="file"
              append-icon="mdi-paperclip"
              prepend-icon=""
              dense
              outlined
              hide-details
              class="c-input-small"
              label="*Ảnh giấy tờ"
              accept="image/*"
              @change="onInputFileChange"
            ></v-file-input>
          </v-col>
          <v-col cols="6">
            <input-qr-scan-model
              v-model="order.contact_value"
              ref="codeRef"
              label="*TT. Liên lạc"
              @keyupEnter="scanInput"
            ></input-qr-scan-model>
          </v-col>
          <v-col cols="6">
            <v-autocomplete
              v-model="order.id_channel"
              class="c-input-small"
              :items="channelOptions"
              dense
              outlined
              hide-details
              label="*Kênh liên lạc"
            ></v-autocomplete>
          </v-col>
          <template v-if="isShowInfo && isShowAll">
            <v-col cols="6">
              <v-text-field
                v-model="order.identification_document_number"
                class="c-input-small"
                dense
                outlined
                hide-details
                label="Số giấy tờ"
              ></v-text-field>
            </v-col>
            <v-col cols="6">
              <v-autocomplete
                v-model="order.id_country"
                class="c-input-small"
                :items="countryOptions"
                dense
                outlined
                hide-details
                label="Quốc tịch"
              ></v-autocomplete>
            </v-col>
            <v-col cols="6">
              <v-autocomplete
                v-model="order.gender"
                class="c-input-small"
                :items="genderOptions"
                dense
                outlined
                hide-details
                label="*Giới tính"
              ></v-autocomplete>
            </v-col>
            <v-col cols="6">
              <v-text-field
                v-model="order.name"
                class="c-input-small"
                dense
                outlined
                hide-details
                label="Tên"
              ></v-text-field>
            </v-col>
            <v-col cols="6">
              <v-autocomplete
                v-model="order.identification_document_type"
                class="c-input-small"
                :items="documentTypeOptions"
                dense
                outlined
                hide-details
                label="*Loại giấy tờ"
              ></v-autocomplete>
            </v-col>
            <v-col cols="6">
              <date-picker-model
                v-model="order.date_of_birth"
                :key="order.date_of_birth"
                :label="$t('Ngày sinh')"
                custom-class="c-input-small input-disabled-bold"
                outlined
                dense
                hide-details
                :single-line="false"
              ></date-picker-model>
            </v-col>
          </template>
        </v-row>
      </v-card-text>
    </v-card>
  </div>
</template>

<script>
import customerInfoMixin from "@/components/rent/customerInfoMixin";

export default {
  name: "CustomerInfo",
  mixins: [customerInfoMixin],
};
</script>
